import AppButton from '../components/form/button.vue';
import AppInput from '../components/form/input.vue';
import AppSelect from '../components/form/select.vue';
import AppForm from '../components/form/form.vue';
import AppTextArea from '../components/form/text-area.vue';
import AppRadio from '../components/form/radio.vue';
import AppFileUpload from '../components/form/file-upload.vue';
import AppCheckbox from '../components/form/checkbox.vue';
import AppToggle from '../components/form/toggle.vue';
import AppIcon from '../components/icon.vue';
import AppImage from '../components/image.vue';
import AppAddressAutocomplete from '../components/form/address-autocomplete.vue';
import AppTagsInput from '../components/form/tags-input.vue';
import AppKeyValueInput from '../components/form/key-value-input.vue';

const components = {
	AppButton,
	AppInput,
	AppSelect,
	AppForm,
	AppTextArea,
	AppRadio,
	AppFileUpload,
	AppCheckbox,
	AppToggle,
	AppIcon,
	AppImage,
	AppAddressAutocomplete,
	AppTagsInput,
	AppKeyValueInput,
};

export const registerGlobalComponents = (app) => {
	Object.keys(components).forEach((componentName) => {
		app.component(componentName, components[componentName]);
	});
};
